import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import groupApi from './api/groupApi'
import VueToast from './plugins/vue-toast';
import wxshare from './assets/js/wxshare'
import VueScroller from 'vue-scroller'
import filter from "./filter";
import { Progress, Header, Button, Toast } from 'mint-ui';
import 'mint-ui/lib/style.css'
import {Popup, Tab, Tabs,NoticeBar,Swipe,SwipeItem} from "vant"


import vconsole from 'vconsole';
if(window.location.origin.includes('beta-')){
  new vconsole();
}

Vue.component(Progress.name, Progress);
Vue.component(Header.name, Header);
Vue.component(Button.name, Button);
Vue.component(Toast.name, Toast);

Vue.use(VueToast);
Vue.use(VueScroller)
Vue.use(Popup).use(Tab).use(Tabs).use(NoticeBar).use(Swipe).use(SwipeItem);
// Vue.use(wxshare);

Vue.config.productionTip = false
Vue.prototype.$api = groupApi;

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
